import React from 'react';
import { rgba } from 'polished';
import styled, { css, keyframes } from 'styled-components';
import { brandColors } from 'styles/colors';

export const PADDING = '30px';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(255, 255, 255, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: ${({ zIndex }) => zIndex};
	animation: ${({ isVisible }) =>
		isVisible
			? css`
					${fadeIn} 0.3s ease-out;
			  `
			: css`
					${fadeOut} 0.1s ease-out;
			  `};
`;

export const ModalContainer = styled.div`
	background: white;
	width: ${({ isFullScreen, width }) =>
		isFullScreen ? '100vw' : width || '500px'};
	height: ${({ isFullScreen, height }) =>
		isFullScreen ? '100vh' : height || '300px'};
	box-shadow: 0 2px 24px 0 ${rgba('#000', 0.09)};
	position: relative;
	display: flex;
	flex-direction: column;
	animation: ${({ isVisible }) =>
		isVisible
			? css`
					${fadeIn} 0.3s ease-out;
			  `
			: css`
					${fadeOut} 0.3s ease-out;
			  `};
`;

export const ModalHeader = styled.div`
	border-bottom: 1px solid ${rgba('#000', 0.09)};
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 48px;
	padding: 0px 30px;
`;

export const ModalTitle = styled.div`
	text-transform: uppercase;
	font-size: 13px;
	font-weight: bold;
	letter-spacing: 0.8px;
`;

export const ModalContent = styled.div`
	flex: 1;
	padding: 20px;
	overflow-y: auto;
`;

export const ModalFooter = styled.div`
	padding: 10px;
	display: flex;
	justify-content: flex-end;
	background-color: #f8f8f8;
`;

export const Button = styled(({ children, ...props }) => (
	<button {...props}>
		<ButtonText>{children}</ButtonText>
	</button>
))`
	outline: 0 none;
	border: 0 none;
	color: inherit;
	font: inherit;
	padding: 0 ${PADDING};

	&[type='submit'] {
		color: ${brandColors.green};
	}

	&:not(:disabled) {
		cursor: pointer;
	}
`;

export const ButtonText = styled.span`
	text-transform: uppercase;
	font-size: 12px;
	font-weight: bold;
	border-bottom: 2px solid transparent;
	transition: border 200ms ease-in-out;
	letter-spacing: 0.8px;

	${Button}:disabled & {
		opacity: 0.4;
	}

	${Button}:not(:disabled):hover &,
	${Button}:not(:disabled):focus & {
		border-color: currentColor;
	}
`;
